module.exports = __webpack_public_path__ + "img/20191029164132360截图20191029155549132.2b9665b9.jpg";